import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-xl text-primary-500"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                91<span className="text-primary-500">黑料</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注于热门爆料、真实内幕与独家黑料内容的资讯聚合平台。挖掘真实料源，了解圈内不为人知的内幕信息。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#!">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#!">快捷链接</a>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#!" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">投稿爆料</a></li>
              <li><a href="#!" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">加入我们</a></li>
              <li><a href="#!" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#!">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-foreground-600"></i>
                </span>
                tips@91heilia.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-foreground-600"></i>
                </span>
                400-888-9191
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-foreground-600"></i>
                </span>
                北京市朝阳区光华路9号
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-700">
            &copy; 2026 91黑料 版权所有 | 黑料不打烊，每日必看
          </p>
          <div className="flex items-center gap-4">
            <a href="#!" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#!" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#!" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}